import React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import styles from "./AnnotationBlock.module.scss";
import window from "../../../lib/WindowExtended";

const AnnotationBlock: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();

  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    window.annotationTextArea = evt.target.value;
  };

  return (
    <React.Fragment>
      <h2>{t("checkout.comments")}</h2>
      <p>
        <strong>{t("general.pleaseNote")}:</strong>{" "}
        {t("checkout.commentsAreProcessedManually")}
      </p>
      <div className={styles.wrapper}>
        <textarea
          onChange={handleChange}
          defaultValue={window.annotationTextArea ?? checkout.customerRemark ?? undefined}
          rows={1}
          placeholder={`${t("form.addComments")}${t("general.optional")}`}
        />
      </div>
    </React.Fragment>
  );
};

export default AnnotationBlock;
